import { Text } from '@/components/domain/rules'
import { useTranslation } from '@/i18n/configs'
import { ReactNode } from 'react'

export const PrivacyPolicy = () => {
  const t = useTranslation()

  return (
    <div className="px-16">
      <article>
        <Text as="p" className="py-16">
          {t('privacy_policy.introduction')}
        </Text>
        <>
          {((): ReactNode => {
            const retElements: ReactNode[] = []
            for (let i = 1; ; i++) {
              const title = t(`privacy_policy.content.${i}.title`, {
                defaultValue: '',
              })
              if (!title) {
                break
              }
              const body = t(`privacy_policy.content.${i}.body`, {
                defaultValue: '',
              })
              if (!body) {
                break
              }
              retElements.push(
                <section
                  key={`privacy-policy-${i}`}
                  aria-labelledby={`privacy-policy-${i}`}
                  className="py-16"
                >
                  <h2 id={`privacy-policy-${i}`}>{title}</h2>
                  <Text as="p" className="whitespace-pre-line">
                    {body}
                  </Text>
                </section>
              )
            }
            return retElements
          })()}
        </>
      </article>
    </div>
  )
}
